<template>
  <section class="hero toronto">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA House, Toronto at CLIO
          </h1>
          <h2 class="hero__date">
            May 14th - May 15th, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
          <div class="btn btn-alt-hero live-stream">
            <a href="https://www.youtube.com/live/VuxjMY6tyzM" target="_blank">
              <button class="button">
                Live Streaming
              </button>
            </a>
          </div>
          <div class="venue-logo">
            <a href="https://maps.app.goo.gl/t2CMkek7JvKFqtfo7" target="_blank">
              <img src="@/assets/general/clio.webp" alt="Clio Logo">
            </a>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.toronto {
    padding: 100px 0 20px;
    min-height: 500px;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 70%) 0%, rgb(0 0 0 /35%)), url('~@/assets/general/Clio.jpg');
  }

  .live-stream {
    margin-top: 20px;
  }
  </style>